import React from "react";
import { IVendorQuery } from "~/lib/queries/__generated__/VendorQuery.generated";
import * as palette from "@govlaunch/palette";
import VendorOwnerInfo from "~/components/vendor/profile/owner/VendorOwnerInfo";
import VendorOwnerNavigation from "~/components/vendor/profile/owner/VendorOwnerNavigation";
import useIsMobile from "~/lib/hooks/useIsMobile";
import { useToggle } from "react-use";
import { MobileScreen, MobileScreenHeader, MobileScreenBody } from "@govlaunch/core";

interface IVendorOwnerSidemenuProps {
  vendor: IVendorQuery["company"];
  tab: string;
}

export default function VendorOwnerSidemenu({ vendor, tab }: IVendorOwnerSidemenuProps) {
  const isMobile = useIsMobile();
  const [isOpen, toggle] = useToggle(false);

  if (!vendor) {
    return null;
  }

  return (
    <div
      css={{
        display: "grid",
        justifyItems: "left",
        alignItems: "center",
        backgroundColor: palette.white,
        borderRadius: 5,
        border: `solid 1px ${palette.lightestGray}`,
        overflow: "hidden",
      }}
    >
      <VendorOwnerInfo vendor={vendor} />

      {!isMobile && (
        <div
          css={{
            width: "100%",
            borderTop: `solid 1px ${palette.lightestGray}`,
          }}
        >
          <div>
            <VendorOwnerNavigation vendor={vendor} tab={tab} />
          </div>
        </div>
      )}

      {isOpen && (
        <MobileScreen isOpen={isOpen}>
          <MobileScreenHeader onRequestClose={toggle}>
            <h1
              css={{
                margin: 0,
                color: palette.text,
                fontSize: 24,
              }}
            >
              {vendor.name}
            </h1>
          </MobileScreenHeader>

          <MobileScreenBody>
            <div onClick={() => setTimeout(toggle, 100)}>
              <VendorOwnerNavigation vendor={vendor} tab={tab} />
            </div>
          </MobileScreenBody>
        </MobileScreen>
      )}
    </div>
  );
}
